export default __webpack_public_path__ + "static/media/35-min.561292f0.jpg";